import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';



@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {

  constructor(private toastr: ToastrService) {

  }

  showWarning(message: string) {
    this.toastr.warning(message);
  }

  showWarningPosition(message: string, position: string = 'toast-bottom-center') {
    this.toastr.warning(message, 'Warning', { positionClass: position });
  }

  showSuccess(message: string) {
    this.toastr.success(message, 'Success!', { toastClass: 'ngx-toastr custom-toast'});
  }
  showmessage(message: string) {
    this.toastr.info(message);
  }
  Showhome(message: string) {
    this.toastr.success(message);
  }
  showError(message: string) {
    this.toastr.error(message, 'Error!',{ toastClass: 'ngx-toastr custom-toast'});
  }

  clearAll() {
    this.toastr.clear();
  }

}
